import Box from "@mui/material/Box";
import { ReactComponent as CareerMapTxt } from "../../../assets/carrer-map-txt.svg";
import { ReactComponent as Logo } from "../../../assets/logo.svg";

const TopBar = () => {
    return (
        <div style={{ width: "100vw", background: "white", position: "relative", borderBottom: "solid 1px  #dcdcdc", zIndex: 10 }}>
            <div style={{ height: "70px", overflow: "hidden" }}>
                <Box sx={{ padding: "20px", display: "flex", alignItems: "center", gap: 8 }}>
                    <Logo />
                    <CareerMapTxt />
                </Box>
            </div>
        </div>
    );
};

export default TopBar;
